import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { SpaDay as SpaDayV1 } from './SpaDay';
import { SpaDayV2Connected } from './v2';
import { SpaDayProps } from './SpaDay.types';

export const SpaDayVersion: FC<SpaDayProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  if (isV2) return <SpaDayV2Connected {...props} />;
  return <SpaDayV1 {...props} />;
};
